"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSelectBoxHeader = exports.RowSelectBox = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var messages = __importStar(require("../translations"));
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_inputs_1 = require("@contrast-security-inc/design-system-inputs");
var rowSelectBoxContainerCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"])));
var RowSelectBox = function (_a) {
    var testId = _a.testId, onChange = _a.onChange, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("div", { className: rowSelectBoxContainerCss },
        react_1.default.createElement(design_system_inputs_1.Checkbox, { isChecked: isSelected, testId: testId, onChange: onChange, onClick: function (event) { return event.preventDefault(); }, "aria-label": formatMessage(messages, 'selectRow'), "aria-selected": isSelected })));
};
exports.RowSelectBox = RowSelectBox;
var RowSelectBoxHeader = function (_a) {
    var isLoading = _a.isLoading, onChange = _a.onChange, isMultiSelect = _a.isMultiSelect, isChecked = _a.isChecked, testId = _a.testId;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    return (react_1.default.createElement("div", { className: rowSelectBoxContainerCss },
        react_1.default.createElement(design_system_inputs_1.Checkbox, { isDisabled: isLoading, onChange: onChange, isMultiSelect: isMultiSelect, isChecked: isChecked, testId: testId, "aria-label": formatMessage(messages, 'selectAllRows') })));
};
exports.RowSelectBoxHeader = RowSelectBoxHeader;
var templateObject_1;
